
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("asNEt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $021dfd2481bed562$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $021dfd2481bed562$export$2e2bcd8739ae039 = {
    'fabric.reactions.add': 'Add reaction',
    'fabric.reactions.error.unexpected': 'Reactions are temporarily unavailable',
    'fabric.reactions.loading': 'Loading...',
    'fabric.reactions.more.emojis': 'More emojis',
    'fabric.reactions.other.reacted.users': '{count, plural, one {and one other} other {and {count} others}}',
    'fabric.reactions.reactwithemoji': 'React with {emoji} emoji',
    'fabric.reactions.summary': 'View all user reactions',
    'reaction-picker-trigger.add.reaction.message': 'Add a reaction',
    'reactions.dialog.close': 'Close',
    'reactions.dialog.emoji.name': '{emojiName}',
    'reactions.dialog.left.navigate': 'Left Navigate',
    'reactions.dialog.reactions.count': '{count, plural, one {# total reaction} other {# total reactions} }',
    'reactions.dialog.right.navigate': 'Right Navigate',
    'reactions.dialog.viewall': 'View all',
    'reactions.dialog.viewall.tooltip': 'View all user reactions'
};

});


//# sourceMappingURL=en_GB.6489291a.js.map
